import { render, staticRenderFns } from "./BenchmarkConfigEditor.vue?vue&type=template&id=fbf8ae64&scoped=true"
import script from "./BenchmarkConfigEditor.vue?vue&type=script&lang=js"
export * from "./BenchmarkConfigEditor.vue?vue&type=script&lang=js"
import style0 from "./BenchmarkConfigEditor.vue?vue&type=style&index=0&id=fbf8ae64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf8ae64",
  null
  
)

export default component.exports